var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { BlueIconButton } from '@hn-ui/buttons';
import { Left, Right } from '@hn-ui/icons';
import { useGoogleAnalytics } from '@happynumbers/front-utils';
import { styled } from 'styled-components';
import Dino from './assets/Dino.svg';
import { gaTrackerIds } from '../../../pages/utils';
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-1qy08sj" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var PreviewContainer = styled.div.withConfig({ displayName: "PreviewContainer", componentId: "sc-1anfjd8" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  transform: ", ";\n  transition: ", ";\n"], ["\n  display: flex;\n  transform: ", ";\n  transition: ", ";\n"])), function (_a) {
    var position = _a.position;
    return "translateX(" + position + "px)";
}, function (_a) {
    var transitionDuration = _a.transitionDuration;
    return "transform " + transitionDuration + "ms linear";
});
var NoSlideImage = styled(Dino).withConfig({ displayName: "NoSlideImage", componentId: "sc-zxnjhx" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 12px auto 0;\n"], ["\n  margin: 12px auto 0;\n"])));
var LevelBlock = styled.div.withConfig({ displayName: "LevelBlock", componentId: "sc-fuzu4z" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0 16px;\n"], ["\n  padding: 0 16px;\n"])));
var LevelWindow = styled.div.withConfig({ displayName: "LevelWindow", componentId: "sc-he2f1f" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  display: flex;\n  z-index: 1;\n  transform: ", ";\n  transition: ", ";\n"], ["\n  position: absolute;\n  display: flex;\n  z-index: 1;\n  transform: ", ";\n  transition: ", ";\n"])), function (_a) {
    var position = _a.position;
    return "translateX(" + position + "px)";
}, function (_a) {
    var transitionDuration = _a.transitionDuration;
    return "transform " + transitionDuration + "ms linear";
});
var LevelText = styled.div.withConfig({ displayName: "LevelText", componentId: "sc-6aygq5" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 288px;\n  text-align: center;\n  z-index: 1;\n"], ["\n  width: 288px;\n  text-align: center;\n  z-index: 1;\n"])));
var PreviewWindow = styled.div.withConfig({ displayName: "PreviewWindow", componentId: "sc-1890vec" })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 210px;\n  width: 100%;\n  border-radius: 8px 8px 0 0;\n  overflow: hidden;\n  margin-bottom: 16px;\n  display: flex;\n"], ["\n  height: 210px;\n  width: 100%;\n  border-radius: 8px 8px 0 0;\n  overflow: hidden;\n  margin-bottom: 16px;\n  display: flex;\n"])));
var Level = styled.div.withConfig({ displayName: "Level", componentId: "sc-147imjy" })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  height: 24px;\n  border-radius: 16px;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  background-color: ", ";\n"], ["\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  height: 24px;\n  border-radius: 16px;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  background-color: ", ";\n"])), function (_a) {
    var active = _a.active, theme = _a.theme;
    return active ? theme.colors.blue95 : theme.colors.black95;
});
var LeftArrowButton = styled(BlueIconButton).withConfig({ displayName: "LeftArrowButton", componentId: "sc-9e0fw5" })(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  padding: 0 8px;\n  justify-content: flex-start;\n  z-index: 2;\n"], ["\n  width: 100%;\n  padding: 0 8px;\n  justify-content: flex-start;\n  z-index: 2;\n"])));
var RightArrowButton = styled(BlueIconButton).withConfig({ displayName: "RightArrowButton", componentId: "sc-15dtahi" })(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 100%;\n  padding: 0 8px;\n  justify-content: flex-end;\n  z-index: 2;\n"], ["\n  width: 100%;\n  padding: 0 8px;\n  justify-content: flex-end;\n  z-index: 2;\n"])));
export var ImgWrapper = styled.div.withConfig({ displayName: "ImgWrapper", componentId: "sc-1cr1pjm" })(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  height: 384px;\n  width: 320px;\n  background-image: url(", ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center -27px;\n"], ["\n  height: 384px;\n  width: 320px;\n  background-image: url(", ");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center -27px;\n"])), function (_a) {
    var imgUrl = _a.imgUrl;
    return imgUrl;
});
var TRANSITION_DURATION = 300;
var PREVIEW_WINDOW_WIDTH = 320;
var LEVEL_WINDOW_WIDTH = 288;
var PackCarousel = function (_a) {
    var data = _a.data;
    var indexOfMediumLevel = data.findIndex(function (_a) {
        var level = _a.level;
        return level === 'medium';
    });
    var startPosition = indexOfMediumLevel === -1 ? 1 : indexOfMediumLevel + 1;
    var _b = useState(-PREVIEW_WINDOW_WIDTH * startPosition), previewPosition = _b[0], setPreviewPosition = _b[1];
    var _c = useState(-LEVEL_WINDOW_WIDTH * startPosition), levelPosition = _c[0], setLevelPosition = _c[1];
    var _d = useState(0), transitionDuration = _d[0], setTransitionDuration = _d[1];
    var isMoreOneLvl = data.length > 1;
    var carouselSlides = useMemo(function () { return (data.length ? __spreadArray(__spreadArray([data[data.length - 1]], data, true), [data[0]], false) : []); }, [data]);
    var carouselSlidesCount = carouselSlides.length - 1;
    var ga4 = useGoogleAnalytics(gaTrackerIds);
    useEffect(function () {
        var isCurrentSlideFirstAndTransitionWasEnd = previewPosition === 0 && levelPosition === 0 && transitionDuration === 0;
        var isCurrentSlideLastAndTransitionWasEnd = previewPosition === -(PREVIEW_WINDOW_WIDTH * carouselSlidesCount) &&
            levelPosition === -(LEVEL_WINDOW_WIDTH * carouselSlidesCount) &&
            transitionDuration === 0;
        if (isCurrentSlideFirstAndTransitionWasEnd) {
            setPreviewPosition(-(PREVIEW_WINDOW_WIDTH * (carouselSlidesCount - 1)));
            setLevelPosition(-(LEVEL_WINDOW_WIDTH * (carouselSlidesCount - 1)));
        }
        if (isCurrentSlideLastAndTransitionWasEnd) {
            setPreviewPosition(-PREVIEW_WINDOW_WIDTH);
            setLevelPosition(-LEVEL_WINDOW_WIDTH);
        }
    }, [carouselSlidesCount, levelPosition, previewPosition, transitionDuration]);
    var handleOnLeftArrowClick = useCallback(function (event) {
        event.stopPropagation();
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('click_pack_level', {
            category: 'Printables',
        });
        var isCarouselPreparedToSlideTransition = transitionDuration === 0 &&
            previewPosition !== 0 &&
            levelPosition !== 0 &&
            levelPosition !== -(LEVEL_WINDOW_WIDTH * carouselSlidesCount) &&
            previewPosition !== -(PREVIEW_WINDOW_WIDTH * carouselSlidesCount);
        if (isCarouselPreparedToSlideTransition) {
            setTransitionDuration(TRANSITION_DURATION);
            setPreviewPosition(function (currentPosition) {
                var newPosition = currentPosition + PREVIEW_WINDOW_WIDTH;
                return Math.min(newPosition, 0);
            });
            setLevelPosition(function (currentPosition) {
                var newPosition = currentPosition + LEVEL_WINDOW_WIDTH;
                return Math.min(newPosition, 0);
            });
            setTimeout(function () {
                setTransitionDuration(0);
            }, TRANSITION_DURATION);
        }
    }, [
        carouselSlidesCount,
        ga4,
        levelPosition,
        previewPosition,
        transitionDuration,
    ]);
    var handleOnRightArrowClick = useCallback(function (event) {
        event.stopPropagation();
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('click_pack_level', {
            category: 'Printables',
        });
        var isCarouselPreparedToSlideTransition = transitionDuration === 0 &&
            previewPosition !== 0 &&
            levelPosition !== 0 &&
            levelPosition !== -(LEVEL_WINDOW_WIDTH * carouselSlidesCount) &&
            previewPosition !== -(PREVIEW_WINDOW_WIDTH * carouselSlidesCount);
        if (isCarouselPreparedToSlideTransition) {
            setTransitionDuration(TRANSITION_DURATION);
            setPreviewPosition(function (currentPosition) {
                var newPosition = currentPosition - PREVIEW_WINDOW_WIDTH;
                var maxPosition = -(PREVIEW_WINDOW_WIDTH * carouselSlidesCount);
                return Math.max(newPosition, maxPosition);
            });
            setLevelPosition(function (currentPosition) {
                var newPosition = currentPosition - LEVEL_WINDOW_WIDTH;
                var maxPosition = -(LEVEL_WINDOW_WIDTH * carouselSlidesCount);
                return Math.max(newPosition, maxPosition);
            });
            setTimeout(function () {
                setTransitionDuration(0);
            }, TRANSITION_DURATION);
        }
    }, [
        carouselSlidesCount,
        ga4,
        levelPosition,
        previewPosition,
        transitionDuration,
    ]);
    var handleOnPreviewClick = useCallback(function () {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('click_pack_preview', {
            category: 'Printables',
        });
    }, [ga4]);
    return (_jsxs(Wrapper, __assign({ "data-testid": 'pack-slider' }, { children: [_jsx(PreviewWindow, __assign({ onClick: handleOnPreviewClick }, { children: carouselSlides.length ? (_jsx(PreviewContainer, __assign({ position: previewPosition, transitionDuration: transitionDuration }, { children: carouselSlides.map(function (_a, idx) {
                        var _b, _c;
                        var level = _a.level, en = _a.en, es = _a.es;
                        return (_jsx(ImgWrapper, { imgUrl: ((_b = en[0]) === null || _b === void 0 ? void 0 : _b.url) || ((_c = es[0]) === null || _c === void 0 ? void 0 : _c.url) }, "" + level + idx));
                    }) }), void 0)) : (_jsx(NoSlideImage, {}, void 0)) }), void 0), _jsx(LevelBlock, { children: _jsxs(Level, __assign({ active: isMoreOneLvl }, { children: [isMoreOneLvl && (_jsxs(_Fragment, { children: [_jsx(LeftArrowButton, __assign({ onClick: handleOnLeftArrowClick }, { children: _jsx(Left, { size: 16 }, void 0) }), void 0), _jsx(RightArrowButton, __assign({ onClick: handleOnRightArrowClick }, { children: _jsx(Right, { size: 16 }, void 0) }), void 0)] }, void 0)), _jsx(LevelWindow, __assign({ position: levelPosition, transitionDuration: transitionDuration }, { children: carouselSlides.map(function (_a, idx) {
                                var level = _a.level;
                                return (
                                // eslint-disable-next-line react/no-array-index-key
                                _jsx(LevelText, { children: level }, "" + level + idx));
                            }) }), void 0)] }), void 0) }, void 0)] }), void 0));
};
export default PackCarousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
